module.exports = __webpack_public_path__ + "static/img/saas3H5.3ebd3b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/saas3H5.png
// module id = TVbW
// module chunks = 0